let ipPromise = null;

// Cars API requires ip_address on /locations and /search. Fetch the public IP
// once per session and cache the in-flight/resolved promise.
export const getClientIp = () => {
  if (!ipPromise) {
    ipPromise = fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => data.ip)
      .catch(() => {
        ipPromise = null;
        return "";
      });
  }
  return ipPromise;
};
